// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

export enum SocialPermissionType {
    PUBLIC,
    COMPANY_AND_CONNECTIONS,
    CONNECTIONS,
    COMPANY

}
export default SocialPermissionType
